import React from "react";
import { Create } from "react-admin";
import IbeSitesForm from "./IbeSitesForm";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";

const IbeSitesCreate = (props) => (
  <div>
    <Breadcrumbs
      aria-label="breadcrumb"
      style={{
        borderRadius: 5,
        background: "white",
        padding: 12,
        border: "1px solid #e0e0e3",
        //marginLeft: 16,
        //marginRight: 30,
        marginTop: 12,
      }}
    >
      <Link color="inherit" href="/ibe_sites">
        IBE Sites
      </Link>
      <Link
        style={{ fontWeight: "bold" }}
        color="textPrimary"
        aria-current="page"
        disabled
      >
        IBE Site
      </Link>
    </Breadcrumbs>
    <Create {...props} component="div">
      <IbeSitesForm />
    </Create>
  </div>
);

export default IbeSitesCreate;
